export const debounce = <A extends unknown[], R = void>(
    cb: (...args: A) => R,
    duration: number,
): ((...args: A) => void) => {
    let timeoutId: NodeJS.Timeout | undefined;

    return (...args: A) => {
        if (timeoutId) clearTimeout(timeoutId);
        timeoutId = setTimeout(() => cb(...args), duration);
    };
};
